import {removeCachedView, removeToken, removeVisitedViews, setToken} from '@/utils/auth.js'
import {getUserSession, logout} from '@/api/auth.api.js'
import defaultAvatar from '@/assets/img/avatar.png'

const user = {
  state: {
    userSession: {
      token: null,
      id: null,//104264XX
      username: null,// xuyd
      nickName: null,// 徐XX
      email: null, // xuyd@sse.com.c
      avatar: null,
      roles: [],
    }
  },
  mutations: {
    setToken: (state, token) => {
      state.token = token;
    },
    setUserSession: (state, userSession) => {
      state.userSession = userSession;
    },
  },
  actions: {
    /**
     * 用户logout
     * @param commit
     */
    doLogout({commit, dispatch, state}) {
      return new Promise((resolve, reject) => {
        // 调用接口
        logout().then(resp => {
          // dispatch('doClearSession');
          commit('setToken', '')
          // commit('setUserSession', null)
          removeToken();
          removeVisitedViews();
          removeCachedView();
          resolve(resp.data);
        }).catch(err => {
          console.error("logout异常，跳转到登录：", err)
          let redirect = window.encodeURIComponent(location.href);
          let loginUrl = "http://47.92.84.69:9900/login?redirect=" + redirect;
          // dispatch('doClearSession');
          commit('setToken', '')
          // commit('setUserSession', null)
          removeToken();
          reject(loginUrl)
        })
      })
    },

    /**
     * 用户个人信息获取
     * @param commit
     */
    doGetUserSession({commit}) {
      return new Promise((resolve, reject) => {
        // 调用接口
        // {userId, userName, avatar, depart, position, roles:[]}
        getUserSession().then(resp => {
          let data = resp.data;
          if (!data || data.isDelete) {
            console.log("当前用户还未生效", data)
            reject("当前用户还未生效");
            return;
          }
          let userSession = data;
          userSession.avatar = data.avatar || defaultAvatar;
          userSession.roles = data.userRoles || [];
          commit('setUserSession', userSession)
          resolve()
        }).catch(err => {
          reject(err);
        });
      });
    }

  }
}

export default user

